// extracted by mini-css-extract-plugin
var _1 = "Gov4OrCuwPD602bY9VeR";
var _2 = "Gov4OrCuwPD602bY9VeR";
var _3 = "jnrt7bAzUZt2AuDVlWzV";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
